module.exports = __webpack_public_path__ + "images/banners/pages_iphone/iphone-page-stores_7b390dd1fe829c225f46987c0c191422.png";